const pageMetaData = {
  home: {
    title: "Work Desk VA | Expert Virtual Assistants",
    description: "Work Desk Virtual Assistants provide a versatile in-house resource across administrative, content, and customer service functions, enabling companies to become more productive and scale as needed."
  },
  about: {
    title: "About-Us | Work Desk VA",
    description: "​​Work Desk Virtual Assistants work with businesses, entrepreneurs, and startup co-founders. Providing professional remote support and services as needed to facilitate operations on a business."
  },
  pricing: {
    title: "Pricing – Work Desk Virtual Assistance",
    description: "Work Desk VA offers affordable packages for outstanding virtual assistant help. Decide on a plan that fits your company’s needs and work with our experts right now."
  },
  contact: {
    title: "Contact Us | Work Desk VA",
    description: "Have a question or need help? Get in touch with Work Desk VAs today for the best support according to your business requirements."
  },
  aisoftware: {
    title: "AI & Software Engineers - Work Desk VA Remote Talent",
    description: "Hire experienced AI, software engineers, developers, QA testers, DevOps specialists, and project managers."
  },
  digitalmarkiting: {
    title: "Digital Marketing Services - Work Desk VA",
    description: "Get expert digital marketing support including email marketing, SEO, content writing, and e-commerce services."
  },
  adminsupport: {
    title: "Admin Support & Customer Support Services - Work Desk VA",
    description: "Professional admin support, customer support, live chat, and technical support services."
  },
  teamservices: {
    title: "Team Services - Work Desk VA Dedicated Teams",
    description: "Scale your business with dedicated remote teams, talent vetting, and professional onboarding services."
  },
  "ai-data-industry": {
    title: "AI & Data Industry Solutions - Work Desk VA",
    description: "Specialized support for AI and data projects including data labeling, prompt writing, and ML support."
  },
  "it-and-software-industry": {
    title: "IT & Software Development Services - Work Desk VA",
    description: "Developer augmentation, QA support, and project coordination for IT and software companies."
  },
  "e-commerce-and-retail-industry": {
    title: "E-commerce & Retail Support Services - Work Desk VA",
    description: "Product listing, order management, and customer support for e-commerce and retail businesses."
  },
  "education-and-coaching-industry": {
    title: "Education & Coaching Support - Work Desk VA",
    description: "LMS management, student support, and content preparation for education and coaching businesses."
  },
  "healthcare-and-wellness-industry": {
    title: "Healthcare & Wellness Support Services - Work Desk VA",
    description: "Medical admin support, patient coordination, and billing follow-up for healthcare providers."
  },
  "marketing-and-advertising-industry": {
    title: "Marketing & Advertising Services - Work Desk VA",
    description: "Email campaigns, SEO, content scheduling, and reporting for marketing and advertising agencies."
  },
  "real-estate-industry": {
    title: "Real Estate Support Services - Work Desk VA",
    description: "Lead generation, CRM updates, and appointment scheduling for real estate professionals."
  },
  "startups-and-entrepreneur-industry": {
    title: "Startup & Entrepreneur Support - Work Desk VA",
    description: "Admin support, pitch deck prep, and calendar management for startups and entrepreneurs."
  },
  blog: {
    title: "Blog - Work Desk VA Remote Work Insights",
    description: "Read articles about remote work, virtual assistants, and remote team management."
  },
  "privacy-policy": {
    title: "Privacy Policy - WorkdeskVA Remote Staffing Solutions",
    description: "Privacy policy for WorkdeskVA - protecting your data and privacy in remote staffing services."
  },
  "refund-policy": {
    title: "Refund Policy - WorkdeskVA Remote Staffing Solutions",
    description: "Refund Policy for WorkdeskVA remote staffing services. Understand our cancellation, refund terms, and service guarantees."
  },
  notFound: {
    title: "Page Not Found - WorkdeskVA",
    description: "The page you're looking for doesn't exist. Return to WorkdeskVA and find the right solution for your hiring needs."
  }
};

export default pageMetaData;
